<template lang="pug">
  app-page(v-app-scroll="handleScroll" title="Мои дела" :loading="loading" :fabItems="fabItems" @search="text => (search = text)")
    list-toolbar(:isLimitView="isLimitView")
    .text-right
      v-chip.ma-2(v-if="search" color="#757575" text-color="white" small label close @click:close="search = null") Поиск:&nbsp;<b>{{ search }}</b>
      v-chip.ma-2(v-if="period" color="#757575" text-color="white" small label close @click:close="setPeriod(null)") Период:&nbsp;<b>{{ period.text }}</b>
      v-chip.ma-2(v-if="selectedStatus" color="#757575" text-color="white" small label close @click:close="selectStatus(null)") <b>"{{ selectedStatus.title }}"</b>

    app-group-animation
      app-group-item(v-for="c in list" :key="c.id" cols="4")
        list-item(:court-case="c" :highlight-text="preparedSearchText" :isLimitView="isLimitView" @click.native="showCaseDetail(c)")

    app-empty-list(v-if="isEmptyList") Не найдено ни одного дела 


    app-dialog(v-model="dialog.addCase" :header="'Добавить дело'" @confirm="addCase()" :confirmDisabled="formNotEmpty()" confirmText="Добавить" width="400")
      v-layout.mt-1
        v-flex(xs12)
          app-select(v-model="caseForm.gasTableType" :items="caseTableTypes" item-text="title" label="Тип дела"  return-object) 
          app-text-field(v-model="caseForm.number" label="№ дела") 
          app-text-field(v-model="caseForm.lawArticle" label="Статья") 
      v-layout.mt-1
        v-flex(xs8)
          app-date-picker(v-model="sessionForm.eventDate" format="YYYY-MM-DD" :viewFormat="'DD.MM.YYYY'" label="Дата заседания")
        v-flex(xs4)
          //-app-select(v-model="sessionForm.eventTime" :items="timeIntervals" label="Время") 
          app-text-field(v-model="sessionForm.eventTime" type="time" label="Время") 
</template>

<script>
import { mapGetters, mapState, mapMutations } from 'vuex'
import caseListItem from './components/caselist/CaseListItem'
import caseListToolbar from './components/caselist/CaseListToolbar'
import { $_app_moment } from "@/common/AppMoment.js"
import moment from '@/common/AppMoment.js'
import Meeting from '@/common/Meeting'
import { caseService } from "@/_services";

import { $_user_role as Role } from '@/common/UserUtils'

export default {
  mixins: [ $_app_moment, Meeting ],
  components: {
    'ListItem': caseListItem,
    'ListToolbar': caseListToolbar
  },

  data () {
    const defaultFormCase = Object.freeze({
                          gasTableType: null,
                          number: null,
                          lawArticle: null,
                          status: null,
                          judge: null,
                          court: null,
                        })
    
    const defaultFormSession = Object.freeze({
                          eventDate: null,
                          eventTime: null
                        })

    return {
      limit: 15,
      search: null,
      dialog: {
        addCase: false
      },
      caseForm: Object.assign({}, defaultFormCase),
      sessionForm: Object.assign({}, defaultFormSession),
      defaultFormSession,
      defaultFormCase
    }
  },

  mounted () {
    this.$store.dispatch('list/INIT', { limitView: this.isLimitView })
    this.$store.dispatch('judge/GET_JUDGE')
  },

  methods: {
    ...mapMutations('list', ['setPeriod', 'selectStatus', 'addCaseToHistory', 'addCaseInCases']),

    addCase () {
      this.caseForm.court = this.JUDGE.court
      this.caseForm.judge = this.JUDGE
      this.caseForm.status = this.statuses.filter(sts => sts.name === "NoName")[0]
      caseService.add(this.caseForm).then(data1 => {
        let obj = {
          eventDate: moment(this.sessionForm.eventDate).format('YYYY-MM-DD') + " " + this.sessionForm.eventTime,
          createDate: moment().format('YYYY-MM-DD HH:mm'),
          caseStatus: this.caseForm.status,
          name: "1 от " +  moment().format('DD.MM.YYYY HH:mm'),
          courtCase: data1
        }
        caseService.addSession(obj).then(session => {
          data1.eventDate=session.eventDate
          this.addCaseInCases(data1)
        })
      })
    },

    showCaseDetail(selectedCase) {
      this.addCaseToHistory(selectedCase)
      this.$router.push({ path: `/case/${selectedCase.id}` })
    },

    handleScroll: function (evt, el) {
      let bottomOffset = el.scrollHeight - window.scrollY
      if (bottomOffset < 2 * window.innerHeight) {
        this.limit += 6
      }
      return false
    },

    resetList () {
      this.limit = 15
    },

    showAddCase () {
      this.caseForm = JSON.parse(JSON.stringify(this.defaultFormCase))
      this.sessionForm = JSON.parse(JSON.stringify(this.defaultFormSession))
      return this.dialog.addCase = true
    },

    formNotEmpty () {
      return this.sessionForm.eventDate && this.sessionForm.eventTime && this.caseForm.gasTableType && this.caseForm.number ? false : true
    }
  },

  watch: {
    cases () {
      this.resetList()
    }
  },

  computed: {
    ...mapState('list', ['selectedStatus', 'selectedSort', 'period',]),
    ...mapGetters('list', ['baseCases','isBaseCasesLoaded', 'statuses', 'caseTableTypes']),
    ...mapGetters('judge', ['JUDGE']),
    ...mapGetters('court', ['court']),
    ...mapGetters('me', ['hasRole']),

    isLimitView() {
      return this.hasRole([Role.limitjudge])
    },

    statusNamed () {
      return this.selectedStatus != null ? this.selectedStatus.title : 'Все'
    },

    loading () {
      return !this.isBaseCasesLoaded
    },

    isEmptyList () {
      return this.isBaseCasesLoaded && this.cases.length == 0
    },

    list () {
      return this.limit ? this.cases.slice(0, this.limit) : this.cases
    },

    preparedSearchText () {
      return this.search && this.search.toLowerCase()
    },

    cases() {
      let list = this.baseCases || []

      if (this.selectedStatus) {
        list = list.filter(c => c.status.value == this.selectedStatus.value)
      }

      if (this.period) {
        list = list.filter(item => moment(item.createDate).isBetween(this.period.start, this.period.end, 'day', '[]'))
      }
      
      if (this.search) {
        list = list.filter(item => !!item.searchlist.find(phrase => phrase.includes(this.preparedSearchText)))
      }

      switch (this.selectedSort) {
        case 1: list.sort((a, b) => a.number.localeCompare(b.number) || b.id - a.id); break;
        case 2: list.sort((a, b) => (a.caseCategory && b.caseCategory && a.caseCategory.title.localeCompare(b.caseCategory.title)) || b.id - a.id); break;
        default: list.sort((a, b) => { if(this.isLimitView && a.eventDate && b.eventDate) { return b.eventDate.localeCompare(a.eventDate) || b.id - a.id } else { return b.createDate.localeCompare(a.createDate) || b.id - a.id } })
      }

      return list
    },

    fabItems () {
      return this.$_meeting_isAvailable ? [{ icon:'add', title:'Добавить дело', action: () =>  this.showAddCase()}] : []
    },

    timeIntervals () {
      var list = []
      for (var i = 8; i < 20; i++) {
        let hour = `0${i}`.slice(-2)
        list.push(`${hour}:00`)
        list.push(`${hour}:30`)
      }
      return list
    },
  },
}
</script>